import * as actionTypes from './actionTypes';

export const openInfoDialog = (myParam) => {
    return {type: actionTypes.OPEN_INFO_DIALOG, payload: myParam}
}

export const closeInfoDialog = (myParam) => {
    return {type: actionTypes.CLOSE_INFO_DIALOG, payload: myParam}
}